import React from 'react';
import { Modal } from 'antd';
import CreateUser from '../pages/NewUser/NewUser';

const EditAdjusterModal = ({ open, handleClose, parentId, currentUserId}) =>
{ 
  return (
    <Modal 
      open={open}
      onCancel={handleClose}
      centered
      footer={null}
    >
          <CreateUser handleClose={handleClose} parentId={parentId} currentUserId={currentUserId} user="Adjuster" userRoles={[4]} create = "Edit" isEdit={true}/>
    </Modal>
  )
};

export default EditAdjusterModal;